import { Reveal } from "@/components/site/Reveal";
import { Zap, Clapperboard, Award } from "lucide-react";

const ITEMS = [
  {
    icon: Zap,
    title: "Ξεχώρισε αμέσως",
    desc: "Τράβα την προσοχή τη στιγμή που χρειάζεται, μέσα σε έναν κόσμο γεμάτο θόρυβο.",
  },
  {
    icon: Clapperboard,
    title: "Ζωντάνεψε το μήνυμά σου",
    desc: "Το βίντεο μετατρέπει μια απλή πληροφορία σε εμπειρία που μένει αξέχαστη.",
  },
  {
    icon: Award,
    title: "Χτίσε κύρος στο brand",
    desc: "Πρόβαλε την εικόνα σου με premium αίσθηση που εμπνέει εμπιστοσύνη.",
  },
];

export const Benefits = () => {
  return (
    <section
      data-testid="benefits-section"
      className="relative bg-secondary py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-6 md:grid-cols-3">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08}>
              <div
                data-testid={`benefit-card-${i}`}
                className="group h-full rounded-2xl border border-border bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-300 hover:shadow-[0_24px_60px_-30px_rgba(39,168,224,0.55)]"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600 transition-colors group-hover:bg-brand-500 group-hover:text-white">
                  <item.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-ink">
                  {item.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-muted-foreground">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
